import { Identified } from "@/types/sdk-types";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getConfigObject, useBaseContent } from "../utils/utils";
import { LocationControllerApi } from "../services";

interface UseProviderGroupListProps {
  locationId: string;
  providerGroupId: string | undefined;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useLocation({
  locationId,
  providerGroupId,
}: UseProviderGroupListProps): useBaseContent<Identified<Location>> {
  return useQuery({
    queryKey: ["provider-group-location-by-id", locationId, providerGroupId],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: !!locationId,
    queryFn: async () =>
      new LocationControllerApi(getConfigObject())
        .getLocationById(
          locationId, //searchString
          providerGroupId //xTENANTID
        )
        .then((it) => it?.data),
  });
}
